import React from 'react';

const StatusBadge = ({ status }) => {
    const statusConfig = {
        // Warning
        pending:        { label: "Pending",        className: "warning" },
        waiting_upload: { label: "Waiting Upload", className: "warning" },
        pending_review: { label: "Pending Review", className: "warning" },

        // Success
        success:        { label: "Success",         className: "success" },
        completed:      { label: "Completed",       className: "success" },
        approved:       { label: "Approved",        className: "success" },
        active:         { label: "Active",          className: "success" },

        // Danger
        failed:         { label: "Failed",          className: "danger" },
        overdue:        { label: "Overdue",         className: "danger" },
        rejected:       { label: "Rejected",        className: "danger" },
        expired:        { label: "Expired",         className: "danger" },

        // Secondary
        cancelled:      { label: "Cancelled",       className: "secondary" },
        closed:         { label: "Closed",          className: "secondary" },
        inactive:       { label: "Inactive",        className: "secondary" },

        // Info
        sent:           { label: "Sent",            className: "info" },
        processing:     { label: "Processing",      className: "info" },
        draft:          { label: "Draft",           className: "info" },
    };

    const config =
        statusConfig[status?.toLowerCase()] ?? {
            label: status
                ?.replace(/_/g, " ")
                ?.replace(/\b\w/g, c => c.toUpperCase()),
            className: "default",
        };

    return (
        <span style = {{
            ...baseStyle, 
            ...styles[config.className]
        }} >
            { config.label }
        </span>
    );
};

const baseStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '4px 10px',
    borderRadius: '999px',
    fontSize: '0.8rem',
    fontWeight: 600,
};

const styles = {
    default:   { background: "#F3F4F6", color: "#374151" },
    warning:   { background: "#FEF3C7", color: "#92400E" },
    success:   { background: "#DCFCE7", color: "#166534" },
    info:      { background: "#DBEAFE", color: "#1D4ED8" },
    danger:    { background: "#FEE2E2", color: "#B91C1C" },
    secondary: { background: "#E5E7EB", color: "#4B5563" },
};

export default StatusBadge;
